module.exports = __webpack_public_path__ + "static/media/gallery.3046118a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/gallery.svg
// module id = 357
// module chunks = 0